// Left in place for backwards compatibility.  Import directly from @core/util instead.
module.exports = require('@core/util/clientlogger');



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/common/src/util/Logger.js